<template>
  <div class="shane_tm_section">
    <div class="shane_tm_copyright">
      <div class="container">
        <div class="inner">
          <p>
            &copy; {{ new Date().getFullYear() }}
            <a
              href="#"
              target="_blank"
              rel="noreferrer"
            >
              yudhadie
            </a>
            . All rights reserved.
          </p>
        </div>
        <!-- End inner -->
      </div>
    </div>
    <!-- End shane_tm_copyright -->
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
